const NGS_SESSION_STORAGE_TOKEN = 'ngs-token';
const NGS_TOKENS = ['ngs-matches', 'ngs-competitions', 'ngs-bbh', 'ngs-highlights'];

export const checkIfNgsTokenExists = () => {
    const token = sessionStorage.getItem(NGS_SESSION_STORAGE_TOKEN);
    const isNGSToken = NGS_TOKENS.includes(token);
    sessionStorage.removeItem(NGS_SESSION_STORAGE_TOKEN);
    return isNGSToken;
};
